var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInformation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "information",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.978,
    height: 19.978,
    viewBox: "0 0 19.978 19.978",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_73728",
    "data-name": "Group 73728"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_73727",
    "data-name": "Group 73727"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1939",
    "data-name": "Ellipse 1939",
    cx: 0.975,
    cy: 0.975,
    r: 0.975,
    transform: "translate(9.013 13.793)",
    fill: "#a7a7a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90749",
    "data-name": "Path 90749",
    d: "M9.989,0a9.989,9.989,0,1,0,9.989,9.989A9.983,9.983,0,0,0,9.989,0Zm0,18.417a8.428,8.428,0,1,1,8.428-8.428A8.424,8.424,0,0,1,9.989,18.417Z",
    fill: "#a7a7a7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90750",
    "data-name": "Path 90750",
    d: "M179.122,128.5A3.125,3.125,0,0,0,176,131.622a.78.78,0,0,0,1.561,0,1.561,1.561,0,1,1,1.561,1.561.78.78,0,0,0-.78.78v1.951a.78.78,0,1,0,1.561,0v-1.269a3.122,3.122,0,0,0-.78-6.144Z",
    transform: "translate(-169.133 -123.486)",
    fill: "#a7a7a7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformation);
export default __webpack_public_path__ + "static/media/information.9222cc578ed0fc7aa5e67b4327148cf4.svg";
export { ForwardRef as ReactComponent };